import { cardNumberValidator } from "cc-tools/card-number-validator";
import { removeNonNumber } from "cc-tools/helpers";

export const cardNumber =
  () =>
  (value: string): boolean => {
    const { isEligible } = cardNumberValidator(removeNonNumber(value));
    // Passes all validations with Luhns Check being the last
    return isEligible;
  };
